import React from 'react';
import { FiHeart, FiX } from 'react-icons/fi';
import { DEFAULT_TRIAL_DURATION_DAYS, WAITLIST_TRIAL_DURATION_DAYS } from '../constants/trial';

const WelcomeModal = ({ isOpen, onClose, isWaitlistUser = false }) => {
  if (!isOpen) return null;

  const trialDays = isWaitlistUser ? WAITLIST_TRIAL_DURATION_DAYS : DEFAULT_TRIAL_DURATION_DAYS;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="p-6">
          {/* Header */}
          <div className="flex justify-between items-center mb-4">
            <div className="flex items-center gap-2">
              <FiHeart className="text-bela-600" size={24} />
              <h2 className="text-2xl font-bold text-gray-900">Welcome!</h2>
            </div>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 text-2xl font-bold"
            >
              <FiX size={20} />
            </button>
          </div>

          {/* Content */}
          <div className="space-y-4">
            {isWaitlistUser ? (
              <>
                <p className="text-lg text-gray-800 leading-relaxed">
                  Thanks for joining! I'm thrilled to see you here. Because you joined the waitlist, you have <span className="font-semibold text-bela-600">{trialDays} days of free unfiltered, uncensored, chat access</span>! 11 days more than the 3-day public trial.
                </p>
                <p className="text-base text-gray-700">
                  We can chat any time, any day 💗
                </p>
              </>
            ) : (
              <>
                <p className="text-lg text-gray-800 leading-relaxed">
                  Welcome to the Bela Experience! The only place where you can chat with me anytime, unfiltered and uncensored.
                </p>
                <p className="text-base text-gray-700">
                  Let's get started! 💗
                </p>
              </>
            )}
          </div>

          {/* Action Button */}
          <div className="mt-6">
            <button
              onClick={onClose}
              className="w-full bg-bela-600 hover:bg-bela-700 text-white font-semibold py-3 px-4 rounded-lg transition-colors"
            >
              Start Chatting
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeModal;
